import { FEATURE_FLAG_API_DICTIONARY } from "constants/features";

export default class FeatureFlags {
  constructor(data = {}) {
    this.data = this.setUpFlags(data);
  }

  get features() {
    return this.data || {};
  }

  get showProgramPartnersFeature() {
    return !!this.data.showProgramPartnersFeature;
  }

  get showProgramPartnersStats() {
    return !!this.data.showProgramPartnersStats;
  }

  get showProcessedClaimsFilterOption() {
    return !!this.data.showProcessedClaimsFilterOption;
  }

  get showInsightsChart() {
    return !!this.data.showInsightsChart;
  }

  // TODO: add more data cleanup as more environment variables are added
  setUpFlags(rawData) {
    const cleanedData = {};

    for (const key in rawData) {
      const currValue = rawData[key];

      if (currValue === "true") {
        // Convert to raw boolean
        cleanedData[FEATURE_FLAG_API_DICTIONARY[key]] = true;
      } else if (typeof currValue === "string") {
        // Convert other strings to array
        cleanedData[FEATURE_FLAG_API_DICTIONARY[key]] = currValue.split(",");
      } else {
        // This shouldn't happen
        console.log(key, currValue);
      }
    }

    return cleanedData;
  }

  static getSingleConfig() {
    return {
      url: `/api/v1/employer/feature_flags`,
      method: "GET"
    };
  }
}
